import { render, staticRenderFns } from "./LeaderRegionRanking.vue?vue&type=template&id=55cca07d&scoped=true&"
import script from "./LeaderRegionRanking.vue?vue&type=script&lang=js&"
export * from "./LeaderRegionRanking.vue?vue&type=script&lang=js&"
import style0 from "./LeaderRegionRanking.vue?vue&type=style&index=0&id=55cca07d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55cca07d",
  null
  
)

export default component.exports